import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import { GLOBAL_STATE, MOBILE_SETTINGS, MOBILE_SETTINGS_VERSIONS } from '../constants/actionTypes'

const mobileSettingsSelectors = (state: RootState) => prop(GLOBAL_STATE, state)

export const mobileSettingsSelector = createSelector(mobileSettingsSelectors, state => state[MOBILE_SETTINGS])

export const mobileSettingsVersionsSelector = createSelector(
  mobileSettingsSelectors,
  state => state[MOBILE_SETTINGS_VERSIONS]
)
